import { AccommodationPlaceRecommendationFragment, AccommodationRoomBlockFragment, Maybe, TravelDistancesBetweenPointsResponseFragment } from '@graphql/generated';

export enum TravelMapBlockType {
  travelMapVenue = 'travelMapVenue',
  travelMapAccommodationsHotel = 'travelMapAccommodationsHotel',
  travelMapAccommodationsCustom = 'travelMapAccommodationsCustom',
  travelMapAccommodationsRoomblock = 'travelMapAccommodationsRoomblock',
}

export type AccommodationItemList = Readonly<{
  id: string;
  type: TravelMapBlockType;
  distance?: Maybe<number>;
  distances?: Maybe<TravelDistancesBetweenPointsResponseFragment>;
  isFavorite?: Maybe<boolean>;
  photoUrl?: Maybe<string>;
  address?: Maybe<string>;
  cutoffDate?: Maybe<string>;
  displayName?: Maybe<string>;
  createdByType?: Maybe<string>;
  isPhotoHidden?: Maybe<boolean>;
  description?: Maybe<string>;
  lat?: Maybe<number>;
  lng?: Maybe<number>;
  rating?: Maybe<number>;
  phone?: Maybe<string>;
  placeId?: Maybe<string>;
  joyPlaceId?: Maybe<string>;
  price?: Maybe<number>;
  strikeoutPrice?: Maybe<number>;
  websiteUrl?: string;
  numberOfRoomsReserved?: Maybe<number>;
  isFromAccommodationCatalog?: boolean;
  isJoyManagedRoomBlock: boolean;
  isCustomLinkEnabled?: Maybe<boolean>;
  accommodationRoomBlock?: Maybe<AccommodationRoomBlockFragment>;
  autoSuggestionRecommendation?: Maybe<AccommodationPlaceRecommendationFragment>;
}>;

export type AccommodationCard = Readonly<{
  id: string;
  type: TravelMapBlockType;
  isFavorite?: Maybe<boolean>;
  distance?: Maybe<number>;
  distances?: Maybe<TravelDistancesBetweenPointsResponseFragment>;
  photoUrl?: Maybe<string>;
  address?: Maybe<string>;
  cutoffDate?: Maybe<string>;
  displayName?: Maybe<string>;
  createdByType?: Maybe<string>;
  isPhotoHidden?: Maybe<boolean>;
  description?: Maybe<string>;
  lat?: Maybe<number>;
  lng?: Maybe<number>;
  rating?: Maybe<number>;
  phone?: Maybe<string>;
  placeId?: Maybe<string>;
  joyPlaceId?: Maybe<string>;
  price?: Maybe<number>;
  strikeoutPrice?: Maybe<number>;
  websiteUrl?: string;
  checkInDate?: Maybe<string>;
  checkOutDate?: Maybe<string>;
  starRating?: Maybe<number>;
  numberOfRoomsReserved?: Maybe<number>;
  currency?: string;
  customPhone?: Maybe<string>;
  accommodationRoomBlock?: Maybe<AccommodationRoomBlockFragment>;
  isFromAccommodationCatalog?: boolean;
  isJoyManagedRoomBlock: boolean;
  isCustomLinkEnabled?: Maybe<boolean>;
  autoSuggestionRecommendation?: Maybe<AccommodationPlaceRecommendationFragment>;
}>;

export type HotelRoomBlock = Readonly<{
  photoUrl?: Maybe<string>;
  // When isBookingLinkDisabled is true, bookingUrl may be null
  // When isBookingLinkDisabled is false, bookingUrl is required (validated at form level)
  bookingUrl?: Maybe<string>;
  isBookingLinkDisabled: boolean;
  checkInDate?: Maybe<Date>;
  checkOutDate?: Maybe<Date>;
  cutoffDate?: Maybe<Date>;
  numberOfRoomsReserved?: Maybe<number>;
  isJoyManagedRoomBlock?: boolean;
  strikeoutPricePerNight?: Maybe<number>;
  pricePerNight?: Maybe<number>;
}>;
